(() => {
  'use strict';
  const bar = document.querySelector('[data-v355-announcement]');
  if (!bar) return;
  const messages = [...bar.querySelectorAll('.v355-announcement-message')];
  if(messages.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let active = 0;
  let interval = null;
  const showNext = () => {
    messages[active].classList.remove('is-active');
    active = (active + 1) % messages.length;
    messages[active].classList.add('is-active');
  };
  const resume = () => {
    if(interval) return;
    interval = window.setInterval(showNext, 4800);
  };
  const pause = () => {
    if(interval){window.clearInterval(interval); interval = null;}
  };
  bar.addEventListener('mouseenter',pause);
  bar.addEventListener('mouseleave',resume);
  bar.addEventListener('focusin',pause);
  bar.addEventListener('focusout',resume);
  document.addEventListener('visibilitychange',()=>document.hidden?pause():resume());
  resume();
})();